// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Whsch","slider":"styles_slider__jVqA2","value":"styles_value__C5VwD"};